import { Checkbox } from "components/ui";
import ComponentAccessControl from "components/essentials/ComponentAccessControl/ComponentAccessControl";
import { PERSONA_UPDATE_PERMISSION } from "components/dashboard/ServiceModule/permissions";

const PersonaStatus = ({ persona, updatePersonaStatus }) => {
    return (
        <ComponentAccessControl
            baseResources={PERSONA_UPDATE_PERMISSION}>
            <Checkbox
                name='status'
                label={persona?.active ? "Active" : "Disabled"}
                inputClass='input-check-grey'
                id='status'
                onChange={() => updatePersonaStatus(persona?.userId)}
                checked={persona?.active}
            />
        </ComponentAccessControl>
    );
};

export default PersonaStatus;
